// extracted by mini-css-extract-plugin
export default {"content":"UserManagementModal_content__mBi3n","manageSection":"UserManagementModal_manageSection__BY5Yu","inviteSection":"UserManagementModal_inviteSection__36OTD"};